import { jsx as _jsx } from "react/jsx-runtime";
import { ObjectInspector } from 'react-inspector';
export function ObjectRenderer({ value, ...other }) {
    return _jsx(ObjectInspector, { data: value, ...other });
}
//# sourceMappingURL=ObjectRenderer.js.map